/**
 * Builds a random string
 * @param {number} [length=6] Desired length of string
 */
export const random = (length = 6) => {
  let text = ""
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  for (let i = 0; i < length; i += 1)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}

export const replaceAll = (source, target, replacement) => {
  return source.replace(new RegExp(target, "g"), replacement)
}

/**
 * Remove non digit characters from a string
 */
export const removeNonDigits = input => {
  return input.replace(/\D/g, "")
}

/**
 * Removes non alpha-numeric chars from a string
 * @param {string} input String to clean up
 */
export const removeNonAlphaNumeric = input => {
  return input.replace(/\W/g, "")
}

/**
 *
 * @param {string} input string
 */
export const buildSlug = input => {
  let slug = input
    .trim()
    .replace(/[^a-z0-9]/gi, "-")
    .toLowerCase()
  if (slug[slug.length - 1] === "-") {
    slug = slug.slice(0, -1)
  }
  return slug
}

/**
 * Cut to long text
 */
export const cut = (target, length, append = "") => {
  if (length && target.length > length) {
    const cutoff = append.length ? length - append.length : length
    return `${target.slice(0, cutoff - 1)}${append}`
  }
  return target
}

/**
 *
 * @param {string} original A full length string
 * @param {string} substring Substring to remove from original
 * @returns Original string if substring was not found. If substring is in original string then the function returns original string without the substring.
 */
export const removeSubstring = (original, substring) => {
  return original.replace(substring, "")
}

/**
 * Get First Name from a full name string
 * @returns The letters before the first space
 */
export const firstName = fullName => {
  if (fullName) {
    const split = fullName.split(" ")
    if (split.length) {
      return split[0]
    }
  }
  return ""
}

/**
 * Get Last Name from a full name string
 * @returns ALl the letters after the first space
 */
export const lastName = fullName => {
  if (fullName) {
    const split = fullName.split(" ")
    if (split.length > 1) {
      split.splice(0, 1)
      const remaining = [...split]
      return remaining.join(" ")
    }
  }
  return ""
}

export const buildURLQueryParams = params => {
  if (
    !params ||
    typeof params !== 'object' ||
    Object.keys(params).length === 0
  ) {
    return ''
  }
  let str = '?'
  Object.keys(params).forEach(key => {
    const value = params[key]
    if(typeof value === "string" && value !== "") {
      if (str !== '?') str += '&'
      str += `${key}=${encodeURIComponent(value.trim())}`
    }
  })
  return str
}
